/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationCommunicationMethod } from './ClaimReservationCommunicationMethod';
import {
    ClaimReservationCommunicationMethodFromJSON,
    ClaimReservationCommunicationMethodFromJSONTyped,
    ClaimReservationCommunicationMethodToJSON,
} from './ClaimReservationCommunicationMethod';

/**
 * 
 * @export
 * @interface ClaimReservation
 */
export interface ClaimReservation {
    /**
     * Timestamp of when the reservation was marked as a no-show by an admin
     * @type {Date}
     * @memberof ClaimReservation
     */
    noShowAt?: Date | null;
    /**
     * Timestamp of when the reservation was marked as checked in by an admin
     * @type {Date}
     * @memberof ClaimReservation
     */
    checkedInAt?: Date | null;
    /**
     * Optional field to capture if the reservation was most recently edited by a claims agent, and who that agent was
     * @type {string}
     * @memberof ClaimReservation
     */
    editedByAgentName?: string | null;
    /**
     * Optional field to capture if the reservation was created internally by a claims agent on behalf of a player, and who that agent was
     * @type {string}
     * @memberof ClaimReservation
     */
    createdByAgentName?: string | null;
    /**
     * Optional free form notes text about a reservation
     * @type {string}
     * @memberof ClaimReservation
     */
    notes: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimReservation
     */
    numberOfTickets: number;
    /**
     * 
     * @type {ClaimReservationCommunicationMethod}
     * @memberof ClaimReservation
     */
    communicationPreference: ClaimReservationCommunicationMethod;
    /**
     * Phone for the reservation, e.g. "123-456-7890"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof ClaimReservation
     */
    phone?: string | null;
    /**
     * Email for the reservation, e.g. "john.doe@example.com"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof ClaimReservation
     */
    email?: string | null;
    /**
     * Name for the reservation, e.g. "John Doe"
     * @type {string}
     * @memberof ClaimReservation
     */
    name: string;
    /**
     * Encoded timeslot for reservation.
     * This value comes from the timeslot availability call of the player data service and internally encodes the
     * reservation location, date, time, and duration info.
     * @type {string}
     * @memberof ClaimReservation
     */
    timeslotId: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimReservation
     */
    createdAt: Date;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimReservation
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof ClaimReservation
     */
    id: string;
}



/**
 * Check if a given object implements the ClaimReservation interface.
 */
export function instanceOfClaimReservation(value: object): value is ClaimReservation {
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('numberOfTickets' in value) || value['numberOfTickets'] === undefined) return false;
    if (!('communicationPreference' in value) || value['communicationPreference'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timeslotId' in value) || value['timeslotId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ClaimReservationFromJSON(json: any): ClaimReservation {
    return ClaimReservationFromJSONTyped(json, false);
}

export function ClaimReservationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservation {
    if (json == null) {
        return json;
    }
    return {
        
        'noShowAt': json['noShowAt'] == null ? undefined : (new Date(json['noShowAt'])),
        'checkedInAt': json['checkedInAt'] == null ? undefined : (new Date(json['checkedInAt'])),
        'editedByAgentName': json['editedByAgentName'] == null ? undefined : json['editedByAgentName'],
        'createdByAgentName': json['createdByAgentName'] == null ? undefined : json['createdByAgentName'],
        'notes': json['notes'],
        'numberOfTickets': json['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodFromJSON(json['communicationPreference']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'timeslotId': json['timeslotId'],
        'createdAt': (new Date(json['createdAt'])),
        'customerId': json['customerId'],
        'id': json['id'],
    };
}

export function ClaimReservationToJSON(value?: ClaimReservation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noShowAt': value['noShowAt'] == null ? undefined : ((value['noShowAt'] as any).toISOString()),
        'checkedInAt': value['checkedInAt'] == null ? undefined : ((value['checkedInAt'] as any).toISOString()),
        'editedByAgentName': value['editedByAgentName'],
        'createdByAgentName': value['createdByAgentName'],
        'notes': value['notes'],
        'numberOfTickets': value['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodToJSON(value['communicationPreference']),
        'phone': value['phone'],
        'email': value['email'],
        'name': value['name'],
        'timeslotId': value['timeslotId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'customerId': value['customerId'],
        'id': value['id'],
    };
}

